(function ($) {
    //############################################
    //#   Copyright DEVION GmbH  2015            #
    //############################################

    var vslider = function() {

        this.slider = undefined;
        this.process = false;
        this.pos = 0;
        this.max = 0;
        this.width = undefined;
        this.myInterval = null;

        this.settings = {
            view_count: 1,
            step_count: 1,
            duration: 3000,
            interval_duration: 6000,
            easing: 'easeOutCubic',
            offset: undefined,
            current_pos: 0,
        };

        this.init = function(slider) {

            var $slide = this;
            //### vars init

            this.slider = slider;
            this.pos = 0;
            this.max = $('.items', slider).first().find('.item').length;

            if (this.settings.offset != undefined) {
                $('.items', slider).css('margin-left', this.settings.offset);
            }

            if (this.width == undefined) {
                this.width = $('.item', slider).eq(0).width();
            }

            $($('.item', slider)[0]).css('left', 0);

            //### click init
            this.slider.attr('unselectable', 'on').css('user-select', 'none').on('selectstart', false);

            //// Next + Back
            $('.prev', this.slider).click(function() {
                $slide.startInterval();
                $slide.slide(-1);
            });
            $('.next', this.slider).click(function() {
                $slide.startInterval();
                $slide.slide(1);
            });

            /// Clickable
            if (this.settings.clickable) {
                $('.item', slider).click(function() {
                    if ($(this).hasClass('before')) {
                        $slide.startInterval();
                        $slide.slide(-1);
                    } else if ($(this).hasClass('after')) {
                        $slide.startInterval();
                        $slide.slide(1);
                    }
                });
            }

            ///// Pointer
            $('.point', slider.parentNode).each(function(index) {
                $(this).click(function() {
                    if (!$(this).hasClass('active')) {
                        $slide.slideTo(index);
                    }
                });
            });

            if (this.settings.autostart) {
                this.slide(1);
            } else {
                this.slideTo(0);
            }
            this.startInterval();

        }

        this.startInterval = function() {
            var $slide = this;
            this.stopInterval();
            if (this.settings.interval_duration > 0 && this.max > this.settings.view_count) {
                this.myInterval = setInterval(function() {
                    $slide.slide(1);
                }, this.settings.interval_duration);
            }
        }

        this.stopInterval = function() {
            if (this.myInterval !== null) {
                clearInterval(this.myInterval);
            }
        }

        this.slideTo = function(new_pos, noAnimation) {
            this.slide(new_pos, true, noAnimation);
        }

        this.slide = function(diff, fix, noAnimation, trycount) {

            trycount = trycount == undefined ? 1 : trycount + 1;

            var $slide = this;
            if (this.process) {
                if (trycount < 3) {
                    setTimeout(function() {
                        $slide.slide(diff, fix, noAnimation, trycount);
                    }, 200);
                }
                return false;
            }
            if (this.max <= this.settings.view_count) {
                noAnimation = true;
            }

            this.process = true;

            var pos_1 = this.pos;
            if (fix == true) {
                var pos_2 = diff * 1 * this.settings.step_count;
                var direction = pos_1 > pos_2 ? -1 : 1;
                var steps = direction == 1 ? pos_2 - pos_1 : pos_1 - pos_2;
            } else {
                var steps = Math.abs(diff * this.settings.step_count * 1);
                var direction = diff < 0 ? -1 : 1;
                var pos_2 = pos_1 + (steps * direction);
            }

            if (pos_2 >= this.max) {
                pos_2 = pos_2 - this.max;
            } else if (pos_2 < 0) {
                pos_2 = this.max + pos_2;
            }

            this.pos = pos_2;
            var ground_zero = this.width * steps * direction;
            var index = Math.ceil(this.pos / this.settings.step_count);

            if (noAnimation == undefined) {
                $('.items', this.slider).css('left', ground_zero);
            }

            $('.items>.item', this.slider).hide();

            var pos;
            var view_steps = steps == 0 ? this.settings.step_count : steps;
            if (direction > 0) {
                var x1 = -1 * view_steps;
                var x2 = this.settings.view_count - this.settings.current_pos;
            } else {
                var x1 = -1 * view_steps - this.settings.current_pos;
                var x2 = this.settings.view_count + view_steps - this.settings.current_pos;
            }

            x2 += this.settings.current_pos;
            var pos_class = '';
            for (var i = x1; i < x2; i++) { //
                pos = pos_2 + i;
                if (pos >= this.max) {
                    pos = pos - this.max;
                } else if (pos < 0) {
                    pos = this.max + pos;
                }

                $('.items', this.slider).each(function(index) {
                    $('>.item', this).eq(pos).show().css('left', $slide.width * i); //.find( '.title' ).html( pos + ':' + pos_2 );
                });

            }

            if ($('.items', this.slider).css('left') == '0px') {
                $slide.process = false;
            } else {
                var item_count = $('.items', $slide.slider).length;
                $('.items', this.slider).each(function(index) {
                    $(this).animate({
                            left: 0
                        },
                        $slide.settings.duration,
                        $slide.settings.easing || "swing",
                        function() {
                            $slide.process = false;
                            if (index == item_count - 1 && $slide.settings.repeat) {
                                $slide.slide(1);
                            }
                        });
                });
            }

            //$slide.startInterval();
            $('.point', this.slider).removeClass('active');
            $('.point', this.slider).eq(index).addClass('active');

            var current = this.pos + this.settings.current_pos;
            if (current >= this.max) {
                current -= this.max
            }
            if (current < 0) {
                current += this.max
            }

            var $items = $('.items>.item', this.slider);
            var $current = $items.eq(current);

            $items.removeClass('c-before c-after');
            if ($current.hasClass('before')) {
                $current.addClass('c-before');
            } else if ($current.hasClass('after')) {
                $current.addClass('c-after');
            }

            $items.removeClass('current before after');
            $current.show().addClass('current');

            var p = current;
            var ci = 1;
            for (var i = 0; i < ci; i++) {
                p = p - 1 < 0 ? this.max - 1 : p - 1;
                $items.eq(p).addClass('before');
            }

            var p = current;
            for (var i = 0; i < ci; i++) {
                p = p + 1 >= this.max ? 0 : p + 1;
                $items.eq(p).addClass('after');
            }

        }
    };
    // <- ############################################


    
  // cookies
  $.each($("#modal-cookies .collapse"), function (index, el) {
    $(el).on("hidden.bs.collapse", function (ev) {
      $(ev.target).prev("legend").removeClass("border-bottom");
    });
    $(el).on("shown.bs.collapse", function (ev) {
      $(ev.target).prev("legend").addClass("border-bottom");
    });
  });

  $("#modal-cookies legend input").on("change", function (e) {
    $(e.target).closest("fieldset").find("input[type=checkbox]").prop("checked", e.target.checked);
  });

  $(".collapse input[type=checkbox]").on("change", function (e) {
    var inputs = $(e.target).closest(".collapse").find("input[type=checkbox]");
    var res = {
      ok: 0,
      error: 0,
    };
    $.each(inputs, function (index, el) {
      el.checked ? res.ok++ : res.error++;
    });
    if (res.ok == inputs.length) {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", true);
    } else {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", false);
    }
  });

  $("#modal-cookies .btn-select-all").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]").prop("checked", true);
    $(e.target).closest("form").submit();
    return false;
  });


  $("#modal-cookies .btn-just-essential").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]:not([disabled])").prop("checked", false);
    $(e.target).closest("form").submit();
    return false;
  });


  $("#modal-cookies form").on("submit", function (e) {
    var valid = [
        "cookiePolicy",
        "matomo",
        "gtag",
        "gmaps",
        "gyt",
        "jameda",
        // "adform",
        // "facebook"
    ];
    var cookieData = {};
    var $form = $(e.target);
    var data = $form.serializeArray();

    $.each(valid, function (i, e) {
      var enable = data.findIndex(function (obj) {
        return obj.name === e;
      }) + 1 > 0;
      cookieData[e] = enable;
    });

    cookieData['cookiePolicy'] = true;

    $.each(cookieData, function (key, enabled) {
      switch (key) {
        case "cookiePolicy":
          break;

        case "matomo":
          if (typeof _paq !== "undefined") {
            if (enabled) {
              _paq.push(["setCookieConsentGiven", 9480]);
            } else {
              _paq.push([
                function () {
                  if (!this.isUserOptedOut()) {
                    _paq.push(["forgetCookieConsentGiven"]);
                  }
                },
              ]);
            }
          }
          break;

        case "gtag":
          if (enabled) {
            if (typeof gtag === "undefined") {
                initGtag();
              }
          }
          break;

        case "gmaps":
          if (enabled) {
            if (typeof gmaps === "undefined") {
                initGMaps();
              }
          }
          break;

        case "gyt":
          if (enabled) {
            if (typeof gyt === "undefined") {
                initYT();
              }
          } else {
              if (typeof gyt !== "undefined") {
                $('.agree', '.modal-yt-video').removeClass('d-none');
                $('.ratio', '.modal-yt-video').addClass('d-none');
                gyt = false;
                delete window.gyt;
              }
            }
          break;

        case "jameda":
            if (enabled) {
                if (!window._jameda) {
                    initJameda();
                }
            }
            break;

        // case "adform":
        //   if (enabled) {
        //     if (!Array.isArray(window._adftrack)) {
        //         initAdform();
        //       }
        //   }
        //   break;

        // case "facebook":
        //     if (enabled) {
        //       if (typeof fbq === "undefined") {
        //         initFBpx();
        //       }
        //   }
        //   break;
      }
    });
    BPM.COOKIESETTING = cookieData;
    createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    $("#modal-cookies").modal("hide");
    return false;
  });

  var checkCookie = function (name) {
    var nameCheck = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameCheck) == 0) return c.substring(nameCheck.length, c.length);
    }
    return null;
  };

  var createCookie = function (name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";

    document.cookie = name + "=" + value + expires + "; path=/; SameSite=Strict";
  };

  var eraseCookie = function (name) {
    createCookie(name, "", -1);
  };

  // var initAdform = function () {
  //   if (!ADFORM_ID || ADFORM_ID == "") {
  //     // console.log('ADFORM_ID: ' + ADFORM_ID);
  //     return false;
  //   }
  //   window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : window._adftrack ? [window._adftrack] : [];
  //   window._adftrack.push({
  //     HttpHost: "track.adform.net",
  //     pm: ADFORM_ID,
  //     divider: encodeURIComponent("|"),
  //     pagename: encodeURIComponent(document.title),
  //   });
  //   (function () {
  //     var s = document.createElement("script");
  //     s.type = "text/javascript";
  //     s.async = true;
  //     s.src = "https://s2.adform.net/banners/scripts/st/trackpoint-async.js";
  //     var x = document.getElementsByTagName("script")[0];
  //     x.parentNode.insertBefore(s, x);
  //   })();
  // };


  var initGtag = function () {
    if (!GTAG_ID || GTAG_ID === '') {
      // console.log('GTAG_ID: ' + GTAG_ID);
      return false;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GTAG_ID);
    (function () {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + GTAG_ID;
      document.head.append(s);
    })();
  };


  var initGMaps = function() {
    var gmaps = true;
    if (!$('.sec-map').length) return;
    $('.sec-map').each(function(index, el) {
      $(el).find('.alert-container')
        .prop('hidden', true);
      $(el).find('.ratio')
        .prop('hidden', false)
        .find('iframe')
        .attr('src', $(el).find('iframe').attr('data-src'));
    });
  };


  var initYT = function() {
    var gyt = true;
    $('.agree', '.modal-yt-video').addClass('d-none');
    $('.ratio', '.modal-yt-video').removeClass('d-none');
  }


  var initJameda = function() {
    window._jameda = true;
    var tag = jQuery(
        '<script />',
        {
            src: "https://cdn1.jameda-elements.de/widgets/siegel/81414091_1/211887/",
            async: "async",
            type: "text/javascript",
        }
    );

    jQuery('.ext_jameda').prepend(tag);

    jQuery('#jameda-widget-container211887')
        .css(
            'background-image',
            "url('https://cdn1.jameda-elements.de/premium/widgets/_images/top10-top20-bg.png')"
        );

    // jQuery('script', '.ext_jameda')
    //     .attr('src', jQuery('script', '.ext_jameda').attr('data-src'));

    jQuery('.ext_jameda').prop('hidden', false);
    console.log('initJameda ok')


    // <script
    //     src=""
    //     type="text/javascript"
    //     async
    // ></script>
  }

  // var initFBpx = function() {
  //   if (!FB_PX || FB_PX === '') {
  //     // console.log('FB_PX: ' + FB_PX);
  //     return false;
  //   }
  //   !function(f,b,e,v,n,t,s)
  //   {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  //   n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  //   if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  //   n.queue=[];t=b.createElement(e);t.async=!0;
  //   t.src=v;s=b.getElementsByTagName(e)[0];
  //   s.parentNode.insertBefore(t,s)}(window, document,'script',
  //   'https://connect.facebook.net/en_US/fbevents.js');
  //   fbq('init', FB_PX);
  //   fbq('track', 'PageView');
  // };

  BPM.COOKIESETTING = JSON.parse(decodeURIComponent(checkCookie("cookieSetting"))) || {
    cookiePolicy: false,
    matomo: false,
    gtag: false,
    gmaps: false,
    gyt: false,
    jameda: false,
    // adform: false,
    // facebook: false,
  };

  BPM.CookiePolicy = function () {};

  BPM.CookiePolicy.cookieDuration = 30; // Tag/e
  BPM.CookiePolicy.cookieName = "cookieSetting";

  $(function () {
    if (!BPM.DNT && BPM.COOKIESETTING.cookiePolicy === false) {
        jQuery("#modal-cookies").modal("show");
    }

    // if (BPM.COOKIESETTING.cookiePolicy === true) {
    //     $("#customCookieModal").prop("checked", true);
    //     $("#cookieSet1").prop("checked", true);
    // }

    if (BPM.COOKIESETTING.matomo === true) {
      $("#customMatomo").prop("checked", true);
      $("#cookieSet3").prop("checked", true);
    }
    // if (BPM.COOKIESETTING.adform === true) {
    //   $("#cookieSet2").prop("checked", true);
    //   $("#customAdform").prop("checked", true);
    //   initAdform();
    // }
    // if (BPM.COOKIESETTING.facebook === true) {
    //   // $("#cookieSet2").prop("checked", true);
    //   $("#customFacebook").prop("checked", true);
    //   initFBpx();
    // }

    // if (BPM.COOKIESETTING.gtag === true) {
    //   $("#customGoogle").prop("checked", true);
    //   initGtag();

    //   if (BPM.COOKIESETTING.gmaps
    //     && BPM.COOKIESETTING.gyt
    //     && BPM.COOKIESETTING.jameda
    //   ) {
    //     $("#cookieSet").prop("checked", true);
    //   }
    // }

    if (BPM.COOKIESETTING.gmaps === true) {
      $("#customGoogleMaps").prop("checked", true);
      initGMaps();

      if (BPM.COOKIESETTING.jameda
      ) {
        $("#cookieSet4").prop("checked", true);
      }
    }

    // if (BPM.COOKIESETTING.gyt === true) {
    //   $("#customYT").prop("checked", true);
    //   initYT();
    // }

    if (BPM.COOKIESETTING.jameda === true) {
      $("#customJameda").prop("checked", true);
      initJameda();
    }


    if (!BPM.DNT) {
      createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    }
  });


  // yt
  $(".modal-yt-video").on("shown.bs.modal", function (e) {
    if ($('.agree', e.target).hasClass('d-none')) {
      $("iframe", e.target).attr("src", $("iframe", e.target).attr("data-src") + "?autoplay=1");
    }
  });


  $(".modal-yt-video").on("hidden.bs.modal", function (e) {
    $("iframe", e.target).attr("src", null);
  });



  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  $(".contact_me").each(function (i, el) {
    var mail = $(el).attr("data-val") || false;
    if (!mail || mail.indexOf("§%§") === -1 || mail.indexOf("%§%") === -1) {
      $(el).attr("data-val", "");
      return;
    }
    mail = mail.replace(/\@/g, "o").replace(/%§%/g, "@").replace(/§%§/g, ".");
    var text = $(el).html().trim();

    var link = $("<a>", {
      href: "mailto:" + mail,
      rel: "nofollow",
      class: ($(el).attr('class') || "").replace('contact_me', ''),
    });
    link.html(!text ? mail : text);
    $(el).replaceWith(link);
  });


  $(".email_decode_me").each(function (i, el) {
    var mail = $(el).attr("data-val") || false;
    if (!mail || mail.indexOf("§%§") === -1 || mail.indexOf("%§%") === -1) {
      $(el).attr("data-val", "");
      return;
    }
    mail = mail.replace(/\@/g, "o").replace(/%§%/g, "@").replace(/§%§/g, ".");
    var text = $(el).html().trim();
    $(el).removeClass('email_decode_me');
    $(el).removeAttr('data-val');
    $(el).html(!text ? mail : (text + ' ' + mail));
  });


  $("html").removeClass("no-js").addClass("js");




    var $slider;

    function slider_history() {

        if ($slider == undefined) {
            //$slider.stopInterval();
            $slider = new vslider;
        }

        var vw = $(window).width();

        $slider.settings.duration = 700;
        $slider.settings.interval_duration = 4000;
        //$slider.settings.autostart = true;
        $slider.settings.step_count = 1;
        $slider.settings.current = 1;
        // $slider.settings.easing = 'easeOutCubic';
        $slider.settings.easing = 'swing';
        $slider.settings.clickable = true;

        if (vw > 976) {
            $slider.width = $('.container').width() / 3;
            $slider.settings.view_count = 3;
            $slider.settings.current_pos = 1;
            if (vw > 1199) {
                $slider.settings.offset = ($('.container').width() / 35) * -1;
            } else {
                $slider.settings.offset = ($('.container').width() / 10) * -1;
            }
        } else {
            $slider.width = $('.container').width();
            $slider.settings.view_count = 1;
            $slider.settings.current_pos = 0;
            if (vw < 768) {
                $slider.settings.offset = 0; // ($('.container').width() / 6.5) * -1;
            } else {
                $slider.settings.offset = ($('.container').width() / 7); // * -1;
            }
        }

        $slider.init($('.slider').first());

    }

    slider_history();


  $(window).resize(
    debounce(function (e) {
        slider_history();

      if ($('.vert-img').length) {
        window.setTimeout(function () {
          $('.vert-img').each(function(index, el) {
            vertImage($(el));
          });
        }, 0);
      }

        slider_history();

    }, 400)
  );


  function smoothScroll(e, direct) {
    var target;
    if (typeof direct === "undefined" || !direct) {
      target = this.hash || window.location.hash;
      target = !target ? $(e.target).closest("a").attr("href") : target;
    } else {
      target = e;
    }

    var $target = $(target).length ? $(target) : $("[name='" + window.location.hash.substr(1) + "']");

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - $('#navbar-main').outerHeight(true),
        },
        400,
        "linear"
        // function() {
        //   window.location.hash = target;
        // }
      );
        // if (!!window.history) {
        //     history.pushState({}, window.title, '#' + $target.attr('id'));
        // }
    return false;
  }

    if (!!window.location.hash) {
        smoothScroll(window.location.hash, 1);
    }


    // scrollto hash
    $(".scrollTo").on("click", function (e) {
        e.preventDefault();
        smoothScroll(e);
        return false;
    });


    $(window).on('scroll', function() {
        if ( $(window).scrollTop() < 10 ) {
            $('#navbar-main').removeClass('sticky-active');
        } else {
            $('#navbar-main').addClass('sticky-active');
        }

        if ( $(window).scrollTop() < 200 ) {
            $('.scroll-up').removeClass('show');
        } else {
            $('.scroll-up').addClass('show');
        }
    });

    var progressPath = document.querySelector('.scroll-up .icon-xxxl path');
    var pathLength = progressPath.getTotalLength();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
    progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
    var updateProgress = function () {
        var scroll = $(window).scrollTop();
        var height = $(document).height() - $(window).height();
        var progress = pathLength - (scroll * pathLength / height);
        progressPath.style.strokeDashoffset = progress;
    }
    updateProgress();
    $(window).scroll(updateProgress);


  // // scrollto navlinks
  // $(".nav-link", "#main-primary-menu").on("click", function (e) {
  //   var href = $(e.target).closest("a").attr("href");
  //   if (href.indexOf("#") + 1 < 1 || window.location.pathname !== "/") return;
  //   smoothScroll("#" + href.split("#").pop(), 1);
  //   $(e.target)
  //     .closest("ul")
  //     .find("li.active")
  //     .removeClass("current-menu-item active current-menu-item current_page_item");
  //   $(e.target).closest("ul").find("a").removeClass("current-menu-item current_page_item");
  //   $(e.target)
  //     .closest("li")
  //     .addClass("current-menu-item active")
  //     .find("a")
  //     .addClass("current-menu-item current_page_item");
  //   return false;
  // });


  // // navlink active link onload
  // $(window).on("load", function (e) {
  //   if (window.location.pathname !== "/") return;
  //   $("#main-primary-menu")
  //     .find("li.active")
  //     .removeClass("current-menu-item active current-menu-item current_page_item");
  //   $("#main-primary-menu").find("a").removeClass("current-menu-item current_page_item");
  //   $("li:first-of-type", "#main-primary-menu")
  //     .addClass("current-menu-item active")
  //     .find("a")
  //     .addClass("current-menu-item current_page_item");
  //   return false;
  // });



  // carousel img repair & touch
  function resizeImage($img) {
    $img.removeClass("resizeVertical");
    console.log('resize', $img.attr('src'))
    if ($img.width() < $img.parent().width() && $img.width() > 0 && $img.height() >= $img.parent().height()) {
      $img.addClass("resizeVertical");
    }
  }
  function vertImage($img) {
    $img.removeClass("resizeVertical");
    console.log('vert', $img.attr('src'))
    if ($img.height() < $img.parent().height() && $img.width() >= $img.parent().width() && $img.width() > 0) {
      $img.addClass("resizeVertical");
    }
  }

  $('img').on('load', function(e) {
    window.setTimeout(function() {
        // if ($(e.target).hasClass('bg-img')) {
        //   resizeImage($(e.target));
        // }
        if ($(e.target).hasClass('vert-img')) {
          vertImage($(e.target));
        }
    }, 0);
  });


  $(".carousel").on("touchstart", function (event) {
    if ($(event.target).closest(".carousel").hasClass("view")) return false;
    var xClick = event.originalEvent.touches[0].pageX;
    $(this).one("touchmove", function (event) {
      var xMove = event.originalEvent.touches[0].pageX;
      var btCarousel = bootstrap.Carousel.getOrCreateInstance(this);
      if (Math.floor(xClick - xMove) > 5) {
        btCarousel.next;
      } else if (Math.floor(xClick - xMove) < -5) {
        btCarousel.prev;
      }
    });
    $(".carousel").on("touchend", function () {
      $(this).off("touchmove");
    });
  });


  if (!!navigator.userLanguage || !!navigator.browserLanguage || !!navigator.systemLanguage) {
    $("body").addClass("ie11");
    // console.log("ie11");
  }


  //
  var bpmShadowSvg = function (icon, classes) {
    return '<div class="svg-wrapper"><svg fill="currentColor"'
      + (!classes || classes.length ? '' : (' class="' + classes.join(' ') + '"'))
      + '><use href="#' + icon + '"/></svg></div>';
  };

  
  var $window = $(window);
  function reRenderMainNav() {
      var $oMainNav = $('#navbar-main').find('.container-fluid'),
          $oNavList = $('#bb4-primary-menu'),
          $oMoreLinks = $oNavList.find('.moreLinks');

      // Abbrechen, wenn Fensterbreite <= 767
      if ($window.width() <= 750) {
          $oMoreLinks.each(function () {
          $(this).addClass('nav-item')
              .find('.dropdown-item')
              .removeClass('dropdown-item')
              .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
          $oMoreLinks.remove();
          return;
      }

      if ($oMoreLinks.length) {
          $oMoreLinks.find('> ul > li').each(function () {
              $(this).addClass('nav-item')
                  .find('> .dropdown-item')
                  .removeClass('dropdown-item')
                  .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
      } else {
          var oMoreLinkElem = document.createElement('li'),
              oMoreLinkAElem = document.createElement('a'),
              oMoreLinkUlElem = document.createElement('ul');

          oMoreLinkElem.className = 'dropdown dropstart moreLinks menu-item nav-item';

          oMoreLinkAElem.className = 'dropdown-toggle nav-link menu-item d-inline-flex align-items-center';
          oMoreLinkAElem.innerHTML = '&nbsp;<div class="icon">' + bpmShadowSvg('svg-ellipsis-h') + '</div>&nbsp;'; // BPM.txt.more;
          oMoreLinkAElem.setAttribute('data-bs-toggle', 'dropdown');

          oMoreLinkUlElem.className = 'dropdown-menu';
          oMoreLinkUlElem.setAttribute('role', 'menu');

          oMoreLinkElem.appendChild(oMoreLinkAElem);
          oMoreLinkElem.appendChild(oMoreLinkUlElem);

          $oNavList.append(oMoreLinkElem);
          $oMoreLinks = $(oMoreLinkElem);
      }

      var iMainNavWidth = $oMainNav.width()
              - $oMainNav.find('.navbar-brand').outerWidth(true)
              - ($oMainNav.find('.item1').outerWidth(true) || 0),
          $oNavItems = $oNavList.find('> li').not('.moreLinks'),
          iNavItemsWidth = 0,
          aMoreLinkElems = [];

      // console.log(iMainNavWidth)
      // console.log($oMainNav.find('.ms-auto.me-0').outerWidth(true));

      $oNavItems.each(function () {
          var $this = $( this );
          iNavItemsWidth += $this.outerWidth(true);
      });

      if (iNavItemsWidth > iMainNavWidth) {
          iMainNavWidth -= Math.ceil($oMoreLinks.outerWidth(true));
          iNavItemsWidth = 0;
          
          $oNavItems.each( function ()
              {
                  var $this = $( this );
                  iNavItemsWidth += $this.outerWidth(true);
              
                  if (Math.ceil(iNavItemsWidth) > iMainNavWidth) {
                      $this.removeClass('nav-item')
                          .find('> .nav-link')
                          .addClass('dropdown-item')
                          .removeClass('nav-link');
                      if ($this.hasClass('active')) {
                          $this.find('> a').addClass('active');
                      }
                      aMoreLinkElems.push( $this );
                  }
              }
          );
      }

      if (aMoreLinkElems.length) {
          $oMoreLinks.find('> ul').append(aMoreLinkElems);
      } else {
          $oMoreLinks.remove();
      }
  }

  $(function () {
      reRenderMainNav();
  });
  $(window).resize(function() {
      reRenderMainNav();
  });

  //////


  // navbar/dropdown toggle
    function toggleDropdown(e) {
      var _d = $(e.target).closest(".dropdown"),
          _m = $(">.dropdown-menu", _d);

      // if ($(e.target).closest(".menu-large")) return;
      setTimeout(
        function () {
          var shouldOpen = e.type !== "click" && _d.is(":hover");
          _m.toggleClass("show", shouldOpen);
          _d.toggleClass("show", shouldOpen);
          $('>[data-bs-toggle="dropdown"]', _d).attr("aria-expanded", shouldOpen);
        },
        e.type === "mouseleave" ? 50 : 0
      );
    }



    function toggleSubDropdown(e) {
      var _d = $(e.target).closest(".dropdown-submenu"),
        _m = $(">.dropdown-menu", _d);
      // if ($(e.target).closest(".menu-large")) return;
      setTimeout(
        function () {
          var shouldOpen = e.type !== "click" && _d.is(":hover");
          _m.toggleClass("show", shouldOpen);
          _d.toggleClass("show", shouldOpen);
          $('>[data-bs-toggle="dropdown"]', _d).attr("aria-expanded", shouldOpen);
        },
        e.type === "mouseleave" ? 50 : 0
      );
    }


    $("body").on("mouseenter mouseleave", ".dropdown", toggleDropdown);
    // $("body").on("mouseenter mouseleave", ".dropend", toggleDropdown);
    // // $("body").on("mouseenter mouseleave", ".dropdown-submenu", toggleSubDropdown);


    // main nav links clickable
    $('[data-bs-toggle="dropdown"]', "ul.navbar-nav").on("click", function(e) {
      if ($(e.target).closest(".menu-large").length) {
        return true;
      }
      e.preventDefault();
      e.stopPropagation();

      // window.location.href = $(this).attr("href");
      return false;
    });


  //////

    // if ("lightbox" in window) {
    //     lightbox.option({
    //       'resizeDuration': 200,
    //       'wrapAround': true
    //     });
    // }


  //////


    //// admin bar fix
    if ($('#wpadminbar').length) {
        $('html').attr('style', function(i,s) { return (s || '') + 'margin-top: 0 !important;' });
    }


    // contact
    $("form[name='contact_form']").on("submit", function(e) {
        e.preventDefault();
        var $form = $(e.target);

        var data = $form.serializeArray();
        data.push({ name: "action", value: "bpmprojectformcontact" });
        data.push({ name: "nonce_in", value: bpm_project_data.nonce_in });

        $form.find(".btn[type=submit]").prop("disabled", true);
        $('.loading').prop('hidden', false);
        $('.is-invalid').removeClass('is-invalid');
        $form.find(".alert").attr('hidden', true).removeClass("alert-danger alert-success show");

        var post = {};
        data.map(function(x) {
            return (post[x.name] = x.value);
        });

        $.ajax({
            url: bpm_project_data.ajax_url,
            type: "POST",
            data: post,
            dataType: "json",
            success: function(json, textStatus, XMLHttpRequest) {
                var messageTxt = "";
                if (!json.success) {
                    for (var i = 0; i < json.errors.length; i++) {
                        for (var key in json.errors[i]) {
                            if (key === 'alert') {
                                messageTxt += json.errors[i][ key ] + "\n";
                            } else {
                                $("[name='" + key + "']")
                                    .addClass('is-invalid')
                                    .closest('.mb-3')
                                    .addClass('is-invalid')
                                    .find('.invalid-feedback')
                                    .text(json.errors[i][ key ]);

                                $("[name='" + key + "']")
                                    .closest('.mb-3')
                                    .find('.invalid-tooltip')
                                    .text(json.errors[i][ key ]);
                            }
                        }
                    }
                    if (messageTxt.trim() == "") {
                        messageTxt = bpm_project_data.errorStandard;
                    }

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            (data.action == 2 ? 'Support' : 'Kontakt') + 'anfrage',
                            window.location.pathname.split('/').filter(Boolean).shift() || "",
                            0
                        ]);
                    }
                } else {
                    $form[0].reset();
                    $(".form-group-captcha", $form).addClass("d-none");
                    messageTxt = json.message || "";

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            (data.action == 2 ? 'Support' : 'Kontakt') + 'anfrage',
                            window.location.pathname.split('/').filter(Boolean).shift() || "",
                            1
                        ]);
                    }
                }

                if (messageTxt.trim() != "") {
                    $form
                        .find(".alert")
                        .attr('hidden', false)
                        .addClass("show alert-" + (!json.success ? "danger" : "success"))
                        .find(".text")
                        .text(messageTxt);
                }

                $form.find(".btn[type=submit]").prop("disabled", false);
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                $form
                    .find(".alert")
                    .attr('hidden', false)
                    .addClass("alert-danger show")
                    .find(".text")
                    .text(
                        MLHttpRequest.status == 403
                        ? bpm_project_data.error403
                        : MLHttpRequest.statusText + " | Errorcode: " + MLHttpRequest.status
                    )

                $form.find(".btn[type=submit]").prop("disabled", false);
            },
            complete: function() {
                $('.loading').prop('hidden', true);
            }
        });

        return false;
    });


    //


    var popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    var popoverList = [...popoverTriggerList].map(function(popoverTriggerEl) {
        new bootstrap.Popover(popoverTriggerEl)
    });


    if ("AOS" in window) {
        AOS.init();
    }


    // tabs
    if (jQuery('.sec-teaser-tabs').length) {
        jQuery('.btn_back', '.sec-teaser-tabs').on('click', function(e) {
            var parent = jQuery(e.target).closest('.sec-teaser-tabs');
            var id = jQuery(e.target).closest('.tab-content').find('.tab-pane').get(0).id;
            var triggerEl = parent.find('button[data-bs-target="#' + id + '"]');
            bootstrap.Tab.getInstance(triggerEl).show();
            beh_interval;
        });
    }

    var beh_interval;
    var behandlungen = function() {

        if (!$('.sec-teaser-tabs').length) return;

        var parent = '.sec-teaser-tabs';

        var maxLi = $('.nav-pills li', parent).length - 1;
        var count = 1;

        beh_interval = setInterval(function() {
            if ($('ul.nav-pills>li button.active:not([hidden])').length) {
                $('.nav-pills li:visible', parent).removeClass('in');
                count = 1;
                return true;
            }
            $('.nav-pills li:visible', parent).removeClass('in');
            $('.nav-pills li:visible', parent).eq(count).addClass('in');
            count += 1;
            if (count > maxLi) {
                count = 1;
            }
        }, 1000);

        $('.nav-pills button', parent).on('click', function(e) {
            if (window.innerWidth < 977) {
                var target = jQuery(jQuery(e.target).closest('button').data('bs-target'));
                if (target.length == 0) target = $('html');
                history.pushState(null, null, this.getAttribute('href'));
                var offset = $(this).data('scrollOffset') ? $(this).data('scrollOffset') : 0;
                $('html, body').animate({
                    scrollTop: target.offset().top - (offset + 89)
                }, 500);
            }
            return false;
        })
    }

    behandlungen();

})(jQuery);



// (function($) {
//     $.fn.countUp = function(options) {
//         options = options || {};
//         this
//             .each(function () {
//                 var val = !! $(this).data('num') ? $(this).data('num') + "" : "";
//                 $(this).data('val', parseInt((val.replace(/[\.,]/,'') || '0'), 10));
//                 this.innerHTML = 0;
//             })
//             .on('inview', function(ev, isInView) {
//                 var i = +$(this).data('val'),
//                     self = this;

//                 if (!isInView) {
//                     self.innerHTML = 0;
//                 } else {
//                     $({n: 0}).stop(true).animate({n: i},
//                         {
//                             duration: $.speed(
//                                 options.duration
//                                 || $(this).data('count-duration')
//                                 || 3500
//                             ).duration,
//                             step: function(now, fx) {
//                                 self.innerHTML = parseInt(now, 10).toLocaleString('de-DE');
//                                 self.setAttribute('data-up', parseInt(now, 10).toLocaleString('de-DE'));
//                             }
//                         }
//                     );
//                 }
//             });
//     };




//     // var slider_praxissss = function() {

//     //     if (!$('.slider_new').length) return;

//     //     // vars zum ändern
//     //     var interval = 5000;
//     //     var currentItem = 0;
//     //     var playing = false;
//     //     var init = true;

//     //     // vars fest
//     //     var slides = document.querySelectorAll('.items .item');
//     //     /*
//     //             for (var i = 0; i < slides.length; i++) {
//     //                 slides[i].style.position = 'absolute';
//     //             }
//     //     */
//     //     var slideInterval = setInterval(nextSlide, interval);
//     //     var nextItem = currentItem == slides.length ? 0 : (currentItem + 1) % slides.length;
//     //     var prevItem = (currentItem - 1) % slides.length < 0 ? slides.length - 1 : (currentItem - 1) % slides.length;
//     //     var direction;

//     //     // controls
//     //     var pauseButton = document.getElementById('pause');
//     //     var next = document.getElementById('next');
//     //     var previous = document.getElementById('prev');

//     //     // init
//     //     nextSlide();
//     //     // show controls
//     //     var controls = document.querySelectorAll('.control');
//     //     for (var i = 0; i < controls.length; i++) {
//     //         controls[i].style.display = 'inline-block';
//     //     }
//     //     init = false;

//     //     function nextSlide() {
//     //         direction = 'right';

//     //         if (document.getElementById('prev').getAttribute('disabled')) {
//     //             document.getElementById('prev').removeAttribute('disabled')
//     //         }

//     //         if (currentItem + 1 == slides.length - 1) {
//     //             pauseSlideshow();
//     //             document.getElementById('next').setAttribute('disabled', 'disabled');
//     //         } else {
//     //             goToSlide(currentItem + 1, direction);
//     //         }

//     //         if (playing == false && init == true) {
//     //             pauseSlideshow();
//     //         }
//     //     }

//     //     function previousSlide() {
//     //         direction = 'left';

//     //         if (document.getElementById('next').getAttribute('disabled')) {
//     //             document.getElementById('next').removeAttribute('disabled')
//     //         }

//     //         if (currentItem - 1 == 0) {
//     //             pauseSlideshow()
//     //             document.getElementById('prev').setAttribute('disabled', 'disabled');
//     //         } else {
//     //             goToSlide(currentItem - 1, direction);
//     //         }

//     //         if (playing == false && init == true) {
//     //             pauseSlideshow();
//     //         }
//     //     }

//     //     function goToSlide(n, direction) {
//     //         /*
//     //                         var oldCurrentItem = slides[currentItem];
//     //                         var oldNextItem = slides[nextItem];
//     //                         var oldPrevItem = slides[prevItem];
//     //         */
//     //         slides[currentItem].className = 'item';
//     //         slides[prevItem].className = 'item';
//     //         slides[nextItem].className = 'item';

//     //         currentItem = (n + slides.length) % slides.length;
//     //         prevItem = (n - 1 + slides.length) % slides.length;
//     //         nextItem = (n + 1 + slides.length) % slides.length;



//     //         setTimeout(function() {
//     //             slides[currentItem].className = 'item active';
//     //             slides[prevItem].className = 'item before';
//     //             slides[nextItem].className = 'item after';
//     //         }, 100)

//     //         /*
//     //                         oldCurrentItem.className = 'item';
//     //                         oldPrevItem.className = 'item';
//     //                         oldNextItem.className = 'item';
//     //         */

//     //     }

//     //     function pauseSlideshow() {
//     //         pauseButton.innerHTML = 'Play';
//     //         playing = false;
//     //         clearInterval(slideInterval);
//     //     }

//     //     function playSlideshow() {
//     //         pauseButton.innerHTML = 'Pause';
//     //         playing = true;
//     //         slideInterval = setInterval(nextSlide, interval);
//     //     }

//     //     pauseButton.onclick = function() {
//     //         if (playing) {
//     //             pauseSlideshow();
//     //         } else {
//     //             playSlideshow();
//     //         }
//     //     };

//     //     next.onclick = function() {
//     //         pauseSlideshow();
//     //         nextSlide();
//     //     };
//     //     previous.onclick = function() {
//     //         pauseSlideshow();
//     //         previousSlide();
//     //     };

//     //     /*
//     //             if (!$('#carousel-praxis').length) return;

//     //             $('.carousel-praxis .item:not( .endpoint )').each(function(index) {
//     //                 var itemToClone = $(this);

//     //                 for (var i = 1; i < 3; i++) {
//     //                     if (i == 1) {
//     //                         itemToClone = itemToClone.prev();
//     //                     } else {
//     //                         itemToClone = itemToClone.next().next();
//     //                     }

//     //                     if (!itemToClone.length) {
//     //                         itemToClone = $(this).siblings(':first');
//     //                     }

//     //                     if (i == 1) {
//     //                         //  console.log(itemToClone.children(''));
//     //                         itemToClone.children(':not(.cloneditem)').clone()
//     //                             .addClass("img-small cloneditem cloneditem-" + (i))
//     //                             .prependTo($(this));
//     //                     } else {
//     //                         itemToClone.children(':not(.cloneditem)').clone()
//     //                             .addClass("img-small cloneditem cloneditem-" + (i))
//     //                             .appendTo($(this));
//     //                     }
//     //                 }
//     //             });

//     //             // height 
//     //             var maxHeight = 0;

//     //             $('.carousel-inner .item .col-xs-12', '.carousel-praxis').each(function() {
//     //                 if ($(this).height() > maxHeight) {
//     //                     maxHeight = $(this).height();
//     //                 }
//     //             })
//     //             $('.carousel-inner .item .col-xs-12', '.carousel-praxis').height(maxHeight);

//     //             // click next/prev ende anfang
//     //             $('#carousel-praxis').on('slide.bs.carousel', function(e) {
//     //                 if ((e.direction == 'left' || e.direction == 'right') && $(e.relatedTarget).hasClass('endpoint')) {
//     //                     e.preventDefault()
//     //                     e.stopPropagation();
//     //                 }
//     //             })
//     //     */
//     //     /*
//     //             if ($slider == undefined) {
//     //                 //$slider.stopInterval();
//     //                 $slider = new vslider;
//     //             }

//     //             $slider.width = 500;
//     //             $slider.settings.duration = 500;
//     //             $slider.settings.step_count = 1;
//     //             $slider.settings.current = 0;
//     //             $slider.settings.easing = 'easeInOutSine';
//     //             $slider.settings.clickable = true;
//     //             $slider.settings.interval_duration = 0;

//     //             //      $slider.width = $('.promo-wrapper').width() / 2.6;
//     //             $slider.width = $('#section--praxis .container').width() / 2.8;
//     //             $slider.settings.view_count = 3;
//     //             $slider.settings.current_pos = 1;

//     //             $('.promo-wrapper.slider').first().find('.item').css('width', $slider.width + 'px');
//     //             $slider.init($('.promo-wrapper.slider').first());
//     //     */
//     // }

//     // slider_praxissss();
// })(jQuery);
